import React from 'react';
import TestPano from '../../assets/images/Test_Pano.jpg';

const PanoramaView = ({ threeSixtyImage = TestPano }) => {
  const theLink = threeSixtyImage?.startsWith('https://')
    ? threeSixtyImage
    : `https://${threeSixtyImage}`;
  return threeSixtyImage ? (
    <iframe src={theLink} width="100%" height="100%" frameBorder="0" allowFullScreen />
  ) : (
    <div style={{ width: '100%', height: '100%', background: 'black' }} />
  );
};

export default PanoramaView;
